import React, { useEffect, useState } from "react";
import { AreaChart, Area, XAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { HoloCard } from "@/components/Holo";
import api from "@/lib/api";

const COLORS = ["#00f0ff", "#ff007f", "#39ff14", "#b026ff", "#eaff00"];

export default function Analytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/analytics").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <div className="font-mono-tech text-white/40 text-sm">Loading analytics...</div>;

  const pie = [
    { name: "Characters", value: d.characters },
    { name: "Products", value: d.products },
    { name: "Scenes", value: d.scenes },
    { name: "Campaigns", value: d.campaigns },
  ].filter((x) => x.value > 0);

  return (
    <div data-testid="module-analytics">
      <div className="mb-8">
        <h1 className="font-display font-bold text-2xl sm:text-3xl">Analytics</h1>
        <p className="font-mono-tech text-white/40 text-sm mt-1">Your creation grid in numbers</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
        {[["Total Renders", d.total_generations, "turquoise"], ["Success Rate", d.success_rate + "%", "green"], ["Campaigns", d.campaigns, "purple"], ["Vault Entries", d.characters + d.products + d.scenes, "pink"]].map(([l, v, a]) => (
          <HoloCard key={l} accent={a} className="p-5" testid={`analytics-stat-${l}`}>
            <div className="font-display font-black text-3xl">{v}</div>
            <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/40 mt-1">{l}</div>
          </HoloCard>
        ))}
      </div>

      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-6">
        <HoloCard accent="turquoise" className="p-6" hover={false}>
          <h3 className="font-mono-tech text-white/50 text-xs uppercase tracking-widest mb-4">// Generations · 7 Days</h3>
          <ResponsiveContainer width="100%" height={240}>
            <AreaChart data={d.activity}>
              <defs>
                <linearGradient id="g" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#00f0ff" stopOpacity={0.5} />
                  <stop offset="100%" stopColor="#00f0ff" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="day" stroke="#555" tick={{ fontSize: 11, fontFamily: "JetBrains Mono" }} />
              <Tooltip contentStyle={{ background: "#0d0d0f", border: "1px solid #222", fontFamily: "JetBrains Mono", fontSize: 12 }} />
              <Area type="monotone" dataKey="generations" stroke="#00f0ff" strokeWidth={2} fill="url(#g)" />
            </AreaChart>
          </ResponsiveContainer>
        </HoloCard>

        <HoloCard accent="pink" className="p-6" hover={false}>
          <h3 className="font-mono-tech text-white/50 text-xs uppercase tracking-widest mb-4">// Vault Distribution</h3>
          {pie.length === 0 ? <div className="font-mono-tech text-white/30 text-sm h-[240px] flex items-center justify-center">No vault data yet</div> : (
            <ResponsiveContainer width="100%" height={240}>
              <PieChart>
                <Pie data={pie} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={3}>
                  {pie.map((e, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} stroke="#050505" />)}
                </Pie>
                <Tooltip contentStyle={{ background: "#0d0d0f", border: "1px solid #222", fontFamily: "JetBrains Mono", fontSize: 12 }} />
              </PieChart>
            </ResponsiveContainer>
          )}
        </HoloCard>
      </div>
    </div>
  );
}
